import {BaseModel} from './BaseModel';
import {TracciatoField} from './TracciatoField';

export class Tracciato extends BaseModel  {
  organizzazioneId: number;
  sorgenteTracciato: number;
  fields?: TracciatoField[];
}
